'use client';
import Link from 'next/link';
import { Product } from '@/models/ProductTypes';
import { CATEGORY_NAME_MAP } from '@/config/constants';

export default function SubNavigation({
  category,
  product,
}: {
  category: keyof typeof CATEGORY_NAME_MAP | 'tilbod';
  product?: Product;
}) {
  return (
    <div className="prose prose-lg flex max-w-none flex-wrap items-center gap-8 md:flex-nowrap md:gap-16">
      <Link className="capitalize text-primary-faded-text-100" href={`/vefverslun`}>
        Vefverslun
      </Link>
      {category && (
        <>
          <div className="text-red-100">•</div>
          <Link className="capitalize text-primary-faded-text-100" href={`/vefverslun/${category}`}>
            {category === 'tilbod' ? 'Tilboð' : CATEGORY_NAME_MAP[category]}
          </Link>
        </>
      )}
      {product && (
        <>
          <div className="text-red-100">•</div>
          <Link className="capitalize text-primary-faded-text-100" href={`/vefverslun/um-voru/${product.productId}`}>
            {product.productName}
          </Link>
        </>
      )}
    </div>
  );
}
